export const Options = {
    Salutation: [
        { text: "männlich", value: "m" },
        { text: "weiblich", value: "w" },
        { text: "divers", value: "d" },
    ],
     BecomingAwareThrough: [
        { text: "Instagram",value:"Instagram"},
        { text: "TikTok",value:"TikTok"},
        { text: "AUBI-plus",value:"AUBI-plus"},
        { text: "Ausbildung.de",value:"Ausbildung.de"},
        { text: "Azubiyo",value:"Azubiyo"},
        { text: "Bundesagentur für Arbeit",value:"Bundesagentur für Arbeit"},
        { text: "Duale Hochschule Baden-Württemberg",value:"Duale Hochschule Baden-Württemberg"},
        { text: "Schülerkarriere",value:"Schülerkarriere"},
        { text: "Studyflix",value:"Studyflix"},
        { text: "Ausbildungsmesse",value:"Ausbildungsmesse"},
        { text: "IHK Speed Dating",value:"IHK Speed Dating"},
        { text: "Schulische Berufsinformationsveranstaltung",value:"Schulische Berufsinformationsveranstaltung"},
        { text: "Printanzeige",value:"Printanzeige"},
        { text: "Mitarbeitende werben Mitarbeitende",value:"Mitarbeitende werben Mitarbeitende"},
        { text: "Sonstiges",value:"Sonstiges"},
    ],
     BecomingAwareThroughLeader: [
        { text: "Homepage der BBBank",value:"Homepage der BBBank"},
        { text: "Google",value:"Google"},
        { text: "Stepstone",value:"Stepstone"},
        { text: "LinkedIn",value:"LinkedIn"},
        { text: "XING",value:"XING"},
        { text: "Instagram",value:"Instagram"},
        { text: "Facebook",value:"Facebook"},
        { text: "Mitarbeitende werben Mitarbeitende",value:"Mitarbeitende werben Mitarbeitende"},
        { text: "Interne Bewerbung",value:"Interne Bewerbung"},
        { text: "Jobteaser",value:"Jobteaser"},
        { text: "Printanzeige",value:"Printanzeige"},
        { text: "Veranstaltung/Messe",value:"Veranstaltung/Messe"},
        { text: "Plakatwerbung/Außenwerbung",value:"Plakatwerbung/Außenwerbung"},
        { text: "Sonstiges",value:"Sonstiges"},
    ],
}
